import { render } from "./SecuritiesHeader.vue?vue&type=template&id=13825ca0&scoped=true&ts=true"
import script from "./SecuritiesHeader.vue?vue&type=script&lang=ts"
export * from "./SecuritiesHeader.vue?vue&type=script&lang=ts"

import "./SecuritiesHeader.vue?vue&type=style&index=0&id=13825ca0&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13825ca0"]])

export default __exports__